import { css } from '@emotion/react'
import { memo } from 'react'
import { toggleAutoPlay } from '../../../../actions/room'
import { SettingsType } from '../../../../constants/enums'
import {
    calculateLoungeSettings,
    ILoungeSettings,
} from '../../../../mfcLogic/lounge'
import i18n from '../../../../utilities/i18n'
import { useSettingSelector } from '../../../Hooks/useSettings'
import AutoPlay from '../../../Icons/AutoPlay'
import { palette } from '../../../styles/colors'
import ChatActionButton from './ChatActionButton'

const activeActionButtonStyles = css({
    color: palette.buttonOutlinedText,
    '& svg': { color: palette.buttonOutlinedText },
})

interface IAutoPlayActionButton {
    id: number
    fullWindow: boolean
}

// put this in its own component so the ChatActionsBar can skip a useSettings call when not in lounge
const AutoPlayActionButton = memo(
    ({ id, fullWindow }: IAutoPlayActionButton) => {
        const [loungeAutoplay] = useSettingSelector(
            SettingsType.ROOM,
            'loungeAutoplay',
        )

        const { autoPlay }: ILoungeSettings =
            calculateLoungeSettings(loungeAutoplay)
        return (
            <ChatActionButton
                testId="IconButton__AutoPlay"
                onClick={() => toggleAutoPlay(id)}
                label={
                    autoPlay
                        ? i18n.t('chat.autoplaying')
                        : i18n.t('chat.startAutoPlaying')
                }
                {...(autoPlay
                    ? {
                          styleOverrides: activeActionButtonStyles,
                      }
                    : {})}
            >
                <AutoPlay
                    active={autoPlay}
                    filled={autoPlay}
                    fullWindow={fullWindow}
                />
            </ChatActionButton>
        )
    },
)

export default AutoPlayActionButton
